<template>
  <div class="home">
      <b-container class="nocon" v-if="showbutton && tourSelect.TPT == 'Y'">
        <template>
          <div class="votePlayerofMonth">
            <template v-if="pollsource == 'B' || pollsource == 'W' && pollgeneral == 'Y'">
              <template v-if="pollappImage != ''">
                <template v-if="pollType == 'E'">
                  <b-link @click="pollTypeEclick">
                    <img class="appImage pulse" :src="pollappImage">
                  </b-link>
                </template>
                <template v-else>
                  <img class="appImage pulse" v-b-modal.modal-xl :src="pollappImage">
                </template>
              </template>
              <template v-else>
                <template v-if="pollType == 'E'">
                  <b-link @click="pollTypeEclick">
                    <b-button variant="success" class="pulse"> Vote for Player of the Month</b-button>
                  </b-link>
                </template>
                <template v-else>
                  <b-button v-b-modal.modal-xl variant="success" class="pulse"> Vote for Player of the Month</b-button>
                </template>
              </template>
            </template>
          </div>
        </template>
      </b-container>

      <!-- Polls Section to test -->
      <b-modal id="modal-xl" size="xl">
        <b-container>
          <div v-for="(box, index) in Extradata" :key="index">
            <template v-if="thankyouMessage == 'N'">
              <div >
                <b-row>
                  <b-col lg="6" sm="12">
                    <img v-if="box.website_image != ''" class="votePicture" :src="box.website_image">
                    <div class="extraPadTop">
                      <b-form-checkbox
                        id="checkbox-2"
                        v-model="terms"
                        name="checkbox-2"
                        value="accepted"
                        unchecked-value="not_accepted"
                      >
                        I accept the <span class="termsandCon" @click="getTermsConditions" v-b-modal.modal-1>terms and conditions</span>
                      </b-form-checkbox>

                      <!-- <div>State: <strong>{{ terms }}</strong></div> -->
                    </div>
                    <b-modal id="modal-1" title="Terms and Conditions" style="height: 600px; overflow: scroll;">
                      <h3 class="my-4 termsTitle" v-html="docTitle"></h3>
                      <p class="my-4 termsContent" v-html="docContent"></p>
                    </b-modal>
                  </b-col>
                  <b-col lg="6" sm="12">
                    <form class="formSection" ref="formdata">
                      <b-row>
                        <b-col lg="6" sm="12">
                          <p class="boxFull" v-if="box.full_desc != ''" v-html="box.full_desc"></p>
                        </b-col>
                        <!-- <b-col lg="6" sm="12">
                          <p class="boxexpiry" v-if="box.end_date != '' && box.end_time != ''" > Vote expiry date: {{box.end_date}} - {{box.end_time}} ({{timeZone}})</p>
                        </b-col> -->
                      </b-row>
                      <template v-if="box.anonymous == 'N'">
                        <b-row>
                          <b-col lg="6" sm="12">
                            <b-form-group
                              id="input-group-1"
                              label-for="input-1"
                            >
                              <b-form-input
                                id="input-1"
                                v-model="polfirstName"
                                type="name"
                                placeholder="Enter First Name"
                                required
                              ></b-form-input>
                            </b-form-group>
                            <b-form-group
                              id="input-group-1"
                              label-for="input-1"
                            >
                              <b-form-input
                                id="input-1"
                                v-model="polSurname"
                                type="name"
                                placeholder="Enter Surname"
                                required
                              ></b-form-input>
                            </b-form-group>
                            <b-form-group
                              id="input-group-1"
                              label-for="input-1"
                            >
                              <b-form-input
                                id="input-1"
                                v-model="polEmail"
                                type="email"
                                placeholder="Enter Email Address"
                                required
                              ></b-form-input>
                            </b-form-group>
                            <!-- <div class="joinFanzon" v-if="box.askfanzone == 'Y'">
                              <b-form-checkbox
                                id="checkbox-1"
                                v-model="fanZonejoin"
                                name="checkbox-1"
                                value="Y"
                                unchecked-value="N"
                              >
                              Join Fanzon
                              </b-form-checkbox>

                            </div> -->
                            <div class="deskHide">
                              <lable v-if="box.multi_select == 'N'">Select one below</lable>
                              <lable v-else>Select one or more below</lable>
                              <b-form-group label="" v-slot="{ ariaDescribedby }">
                                <b-row>
                                  <template v-if="box.multi_select == 'N'">
                                    <b-col lg="12" sm="12" v-for="(op, index) in box.opts.opts_entry" :key="index">
                                      <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                        {{op.desc}}
                                      </b-form-radio>
                                      <template v-if="box.showvotes == 'Y'">
                                        <span v-if="op.votes !== '0'" class="opt">{{op.votes}}</span>
                                      </template>
                                    </b-col>
                                  </template>
                                  <template v-else>
                                    <b-col lg="12" sm="12">
                                      <div v-for="(op, index) in box.opts.opts_entry" :key="index">
                                        <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                        <label class="multiLable" :for="op.desc">{{op.desc}}</label>
                                        <template v-if="box.showvotes == 'Y'">
                                          <span v-if="op.votes !== '0'" class="opt">{{op.votes}}</span>
                                        </template>
                                      </div>
                                    </b-col>
                                  </template>
                                </b-row>
                              </b-form-group>
                            </div>
                            <!-- <div class="mt-3">Selected: <strong>{{ Polselected + 1 }}</strong></div> -->
                            <template v-if="polEmail !== '' && polEmail.includes('@') && polfirstName !== '' && polSurname !== '' && terms == 'accepted'">
                              <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                            </template>
                            <template v-else>
                              <b-button disabled class="buttonVote des">Submit Vote</b-button>
                            </template>
                          </b-col>
                          <b-col lg="6" sm="12" class="mobHide">
                            <lable v-if="box.multi_select == 'N'">Select one below</lable>
                            <lable v-else>Select one or more below</lable>
                            <b-form-group label="" v-slot="{ ariaDescribedby }">
                              <b-row>
                                <template v-if="box.multi_select == 'N'">
                                  <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                    <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                      {{opts.desc}}
                                    </b-form-radio>
                                    <template v-if="box.showvotes == 'Y'">
                                      <span v-if="opts.votes !== '0'" class="opt">{{opts.votes}}</span>
                                    </template>
                                  </b-col>
                                </template>
                                <template v-else>
                                  <b-col lg="12" sm="12">
                                    <div v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                      <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                      <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                      <template v-if="box.showvotes == 'Y'">
                                        <span v-if="opts.votes !== '0'" class="opt">{{opts.votes}}</span>
                                      </template>
                                    </div>
                                  </b-col>
                                </template>
                              </b-row>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col lg="12" sm="12">
                            <b-form-group
                              id="input-group-1"
                              label-for="input-1"
                            >
                              <b-form-input
                                id="input-1"
                                v-model="polEmail"
                                type="email"
                                placeholder="Enter Email Address"
                                required
                              ></b-form-input>
                            </b-form-group>
                            <b-form-group label="Select one below" v-slot="{ ariaDescribedby }">
                              <b-row>
                                <template v-if="box.multi_select == 'N'">
                                  <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                    <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                      {{opts.desc}}
                                    </b-form-radio>
                                    <template v-if="box.showvotes == 'Y'">
                                      <span v-if="opts.votes !== '0'" class="opt">{{opts.votes}}</span>
                                    </template>
                                  </b-col>
                                </template>
                                <template v-else>
                                  <b-col lg="12" sm="12">
                                    <div v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                      <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                      <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                      <template v-if="box.showvotes == 'Y'">
                                        <span v-if="opts.votes !== '0'" class="opt">{{opts.votes}}</span>
                                      </template>
                                    </div>
                                  </b-col>
                                </template>
                              </b-row>
                            </b-form-group>
                            <template v-if="polEmail !== '' && polEmail.includes('@') && terms == 'accepted'">
                              <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                            </template>
                            <template v-else>
                              <b-button disabled class="buttonVote des">Submit Vote</b-button>
                            </template>
                          </b-col>
                        </b-row>
                      </template>
                    </form>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template v-else>
              <b-row>
                <b-col lg="6" sm="12">
                  <img v-if="box.website_image != ''" class="votePicture" :src="box.website_image">
                </b-col>
                <b-col lg="6" sm="12">
                  <template v-if="voteData.status == 'FAIL'">
                    <h2 class="thankyou" v-html="voteData.message"></h2>
                  </template>
                  <template v-else>
                    <h2 class="thankyou">Thank you for your Vote</h2>
                  </template>
                </b-col>
              </b-row>
            </template>
          </div>
        </b-container>
      </b-modal>
      <!-- End of Polls Section to test -->   
      <template v-if="this.okfound == 'Y' & this.course !== null">
        <div id="slider">
          <HomeTab
            :Year="season"
            :courseCode="course"
            :reportURL="currentReport"
            :currentReport="reportTitle"
            :currentTitle="currentTitle"
            :config="config"
            :scoreFound="scoreFound"
            :showGender="showGender"
            :is_qualifier="is_qualifier"
            :stableford="stableford"
            :match="match"
            :useName="tm_params.use_full_name"
          />
        </div>
      </template>
      <div>
        <Slider :Year="tm_params.tm_params.season_code" :config="config" :DEFIMAGESAMS3="DEFIMAGESAMS3"/>
      </div>
      <div>
        <Cubes :config="config"/>
      </div>
      <div id="footer">
        <Footer :white="white" :config="config"/>
      </div>
  </div>
</template>

<script>
import Slider from "@/components/slider.vue";
import Cubes from "@/components/cubes.vue";
import Footer from "@/components/footer.vue";
import HomeTab from "@/components/Hometabone.vue";
import apiCall from "@/services/api.js";
import axios from "axios";
import * as CryptoJS from 'crypto-js';
export default {
  name: "home",
  props:["config"],
  components: {
    Slider,
    Cubes,
    Footer,
    HomeTab,
  },
  data: function() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
      cryptoAES: CryptoJSAesJson,
      tm_params: [],
      reports: [],
      course: [],
      season: [],
      white: true,
      pollData:[],
      polEmail: '',
      polfirstName: '',
      polSurname:'',
      Polselected: '',
      selectedPol:[],
      MultiPolselected: [],
      showbutton: '',
      timeZone: '',
      selectedItems: [],
      showbuttonExtra: [],
      appImage: '',
      // fanZonejoin: 'Y',
      thankyouMessage: 'N',
      voteData: {},
      terms: '',
      docTitle: '',
      docContent:'',
      pollsource: '',
      pollgeneral: '',
      pollMselect: '',
      pollappImage: '',
      pollType: '',
      pollTypeLink: '',
      Extradata: [],
      tourSelect: '',
    };
  },
  computed: {
    filterReports: function() {
      if (Array.isArray(this.reports)) {
        return this.reports.filter(
          (reports_entry) =>
            reports_entry.report_title.includes("Tournament Entries") ||
            reports_entry.report_title.includes("Score") ||
            // reports_entry.report_title.includes("Live") ||
            reports_entry.report_title.includes("Final")
        );
      } else return this.reports; 
    },
    currentTitle: function() {
      if (Array.isArray(this.filterReports))
        return this.filterReports[this.filterReports.length - 1].report_title;
      else return this.filterReports.report_title;
    },
    currentReport: function() {
      if (Array.isArray(this.filterReports))
        return this.filterReports[this.filterReports.length - 1].report_url;
      else return this.filterReports.report_url;
    },
    reportTitle: function(url) {
      if (this.currentReport.indexOf("tmentry") !== -1) {
        url =
          this.config.VUE_APP_APIFULL_URL +
          this.tm_params.tm_params.season_code +
          "/" +
          this.tm_params.tm_params.season_code +
          "-" +
          this.course +
          "-entryw-entries.json?randomadd=" +
          new Date().getTime();
      } else if(this.currentReport.indexOf("tmentry") !== -1){
        url =
          this.config.VUE_APP_APIFULL_URL +
          this.tm_params.tm_params.season_code +
          "/" +
          this.tm_params.tm_params.season_code +
          "-" +
          this.course +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.currentReport.indexOf("tmscore") !== -1) {
          var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
          var indNext2 = this.currentReport.indexOf("~", subRep2);
          var repParams = this.currentReport.substr(
            subRep2,
            indNext2 - subRep2
          );

          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
              this.config.VUE_APP_APIFULL_URL +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
            // var url = "http://dev-auspga.ocs-software.com/api/" + "dev" + "/cache/" + "dev" + "/" + "215S" + "/" + "215S" + "-" + "AUS7" + "-scores-" + $scope.repParams + ".json"+"?randomadd=1603894106415";
          } else {
            url =
              this.config.VUE_APP_APIFULL_URL +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
            // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
          }
        } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
          {
            url =
              this.config.VUE_APP_APIFULL_URL +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
            // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
          }
        } else if (this.currentReport.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            this.config.VUE_APP_APIFULL_URL +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.currentReport.indexOf("tmresult") !== -1) {
          var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
          var indNext1 = this.currentReport.indexOf("~", subRep1);
          var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          console.log("resNum === ");
          console.log(resNum1);
          url =
            this.config.VUE_APP_APIFULL_URL +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            this.config.VUE_APP_APIFULL_URL +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    },
  },
  methods: {
    getPolls() {
      axios
        .get(
          process.env.VUE_APP_APIFULL_URL +
            "tmticx?randomaddText=" +
            new Date().getTime()
        )
        .then(response => {
          this.Extradata = response.data;
          this.pollData = response.data.tm_params.polls;
          if (this.pollData != '') {
            this.showbutton = 'Y'
            if (Array.isArray(response.data.tm_params.polls.polls_entry)) {
              this.Extradata = response.data.tm_params.polls.polls_entry
            } else {
              console.log("is not Array");
              this.Extradata = [response.data.tm_params.polls.polls_entry];
            }
            // let arr = [];
            // console.log("this.arr")
            // console.log(arr)
            // this.Extradata.forEach((value, index) => {
            //     arr.push(value);
            //     console.log(value.source);
            //     console.log(index);
            // });
            this.pollsource = this.pollData.polls_entry.source;
            this.pollgeneral = this.pollData.polls_entry.general;
            this.pollMselect = this.pollData.polls_entry.multi_select;
            this.pollappImage = this.pollData.polls_entry.app_image;
            this.pollType = this.pollData.polls_entry.type;
            this.pollTypeLink = this.pollData.polls_entry.link_url;
            this.tourSelect = this.pollData.polls_entry.tours.tours_entry[1];
            console.log("this.tourSelect")
            console.log(this.tourSelect)
          } else {
            this.showbutton = 'N'
          }
        })
    },
    // Submiting Data for Polls when Anonymous is set to N
    sendPolls() {
      console.log('IN Send Polls')
      // MultiPolselected
      let voteCode = [];
      this.Extradata.forEach((value) => {
          voteCode.push(value.code);
      });
      this.voteCode = voteCode;
      this.selectedPol = this.Polselected + 1;
      let multiSeleted = []
      console.log("multiSeleted")
      console.log(multiSeleted)
      this.selectMulti = multiSeleted;

      this.MultiPolselected.forEach((value) => {
          multiSeleted.push(value);
      });

      if (this.pollMselect == 'Y') {
        console.log('MultiSelect')
				let sendpolls = '';

				sendpolls += 'tpt' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
				for (const i of this.selectMulti) {
					sendpolls += 'option_' + (i) + '|~' + 'Y<!/D>';
        }
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        // let sendpolls = "let " + this.polEmail + " . W 'fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + this.leg  + "|~Y<!/D>'"
        return sendpolls 
      } else if(this.pollType == 'E') {
        console.log('Poll Type == E')
        let sendpolls = '';
        sendpolls += 'tpt' + ' ';
        sendpolls += '.'  + ' ';
        sendpolls += '. W ';
        sendpolls += "'";
        sendpolls += "code|~" + this.voteCode + "<!/D>";
        sendpolls += 'option_1' + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      } else {
        console.log('NON MultiSelect')
        // let sendpolls = "let " + this.polEmail + '. W' + "'" + "fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + "option_" + this.selectedPol + "|~Y<!/D>" + "fz|~" + this.fanZonejoin + "<!/D>" + "'"
        let sendpolls = '';

				sendpolls += 'tpt' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
				sendpolls += 'option_' + this.selectedPol + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      }
		}, 
    pollTypeEclick() {
      let sktMsg = this.sendPolls()
      console.log("sktMsg")
      console.log(sktMsg)
      console.log('Send Poll Data -- E')
      this.$socket.emit('vote', sktMsg);
      window.open(this.pollTypeLink, '_blank');
    },
    sendPollsData() {
      let sktMsg = this.sendPolls()
      console.log("sktMsg")
      console.log(sktMsg)
      // this.$socket.emit('vote', sktMsg);
      this.$socket.emit('vote', sktMsg, (data) => {
        const jsonDoc = JSON.parse(data);
        this.voteData = jsonDoc;
        console.log("data")
        console.log(data)
      });
      this.thankyouMessage = 'Y' 
    },
    getTermsConditions: function() {
      axios
        .get(
          "https://ocs-tpt.com/apps/marketing-terms.php?action=latest&tour=" + 'tpt' + "&?randomadd=" +
            new Date().getTime()
        )
        .then((response) => {
          // this.showTerms = 'Y';
          // console.log("this.showTerms")
          // console.log(this.showTerms)
          this.docTitle = this.base64Decode(response.data.documents.document.title);
          console.log("this.docTitle")
          console.log(this.docTitle)
          this.docContent = this.base64Decode(response.data.documents.document.content);
          console.log("this.docContent")
          console.log(this.docContent)
        });
    },
  },
  //  metaInfo() {
  //    //Injects Meta and Title to Head
  //    return {
  //      title: this.title.content,
  //      meta: [
  //        {
  //          name: this.description.name,
  //          content: this.description.content
  //        }
  //      ]
  //    };
  //  },
    created() {
    apiCall 
      .tmParamsBase()
      .then(({ data }) => {
        this.getPolls();
        this.DEFIMAGESAMS3 = data.tm_params.DEFIMAGESAMS3;
        this.tm_params = data;
        this.course = data.code;
        this.okfound = data.ok_found;
        this.reports = data.reports.reports_entry;
        this.season = data.tm_params.season_code;
        this.course = data.code;
        this.showGender = data.show_gender;
        this.tourinfo = data;
        this.is_qualifier = data.is_qualifier;
        this.stableford = data.stableford;
        this.match = data.match_play;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },

};
</script>
<style scoped>
.votePlayerofMonth {
    margin-top: 40px;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
div#modal-1___BV_modal_content_ {
    height: 600px;
    overflow: scroll;
}
span.termsandCon {
  text-decoration: underline;
}
h2.thankyou {
  color: #00477c;
  text-align: center;
  margin-top: 120px;
}
.extraPadTop {
  padding-top: 30px;
}
.opt {
  position: absolute;
  right: 0;
  top: 0;
}
.multiLable {
  padding-left: 15px;
}
.appImage {
  width: 300px;
  position: absolute;
  right: 12em;
  margin-top: 18px;
}
.appImageLeft {
  width: 300px;
  position: absolute;
  left: 11em;
  margin-top: 18px;
}
::v-deep header#modal-xl___BV_modal_header_ {
  display: none!important;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  display: none!important;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(82, 255, 131, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
button.btn.btn-success {
  /* position: absolute; */
  right: 14em;
  margin-top: 0px;
  width: 100%;
  height: 50px;
  margin-bottom: 90px;
  background-color: #1C2335;
  border-color: #1C2335;
}
button.btn.buttonVote.des.btn-secondary.disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
}
p.boxFull {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 0px;
}
.boxexpiry {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 30px;
}
.formSection {
  padding-top: 30px;
  background: white;
  padding: 40px;
  font-size: 13pt;
  color: #00477c;
  padding-top: 0px;
}
.votePicture {
  width: 100%;
}
.buttonVote {
  background-color: #01477b;
  border-radius: 0;
  padding: 11px 30px;
  margin-bottom: 8px;
  border-color: #01477b;
  margin-top: 20px;
}
.playerofMonth {
  font-size: 2rem;
  color: #01477b;
  font-weight: 400;
  padding-bottom: 20px;
}
/* home partial css */
::v-deep div#entries {
    height: 416px;
    display: block;
    overflow: scroll;
}
::v-deep .entries .LeftAlign {
    text-align: left;
    padding-left: 30px;
}
::v-deep .entries th:first-child {
    text-align: center;
    display: none;
}
::v-deep .entries td.posnum  {
    padding: 5px;
    /* padding-top: 4px; */
    padding-top: 7px;
    padding-bottom: 7px;
    display: block;
    max-width: 58px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2px;
    margin-bottom: 0px;
    color: #6c6c6c;
    font-weight: bold;
    display: none;
}
::v-deep .table-responsive.homeresponse {
  margin-bottom: 0px;
}
.homeresponse {
  margin-bottom: 0px;
}
.cell{
  width: 10%;
  text-align: center;
  font-size: 11pt;
}

::v-deep .pos{
  color: #212529;
  font-size: 10pt;
  background-color: transparent;
}
::v-deep h2.fullnameandDates {
  font-size: 11pt;
  padding: 20px;
  color: #ffffff;
  margin-bottom: 0;
  margin-top: 0;
  text-align: center;
}
/* End of partial css */
::v-deep img.app {
  width: 140px!important;
}
#slider{
  padding-top: 50px;
}
.homeSplash {
  margin-top: -8%;
  width: 100%;
}
::v-deep .jumbotron {
  position: absolute;
  top: 0;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  padding: 22rem 28rem 22rem 6rem;
}
::v-deep .display-3 {
  color: white;
  font-size: calc(2vw + 2vh);
  text-shadow: 2px 2px 4px #000000;
  width: 80%;
  font-weight: 400;
  line-height: 1.2;
}
::v-deep .lead {
  color: #CC444A;
  font-size: 3rem;
  font-weight: 500;
  font-style: italic;
  margin-top: 40px;
  margin-bottom: 55px;
}
.btn {
  background-color: transparent;
  border-color: white;
  font-size: 1.5rem;
  border-radius: 0;
  /* width: 25%; */
}
::v-deep .carousel {
  position: relative;
}
#social {
  padding: 0px;
}

@media only screen and (max-width: 768px) {

  .lead {
    font-size: 2rem;
  }
  .display-3 {
    color: white;
    font-size: calc(2vw + 2vh);
    text-shadow: 2px 2px 4px #000000;
    width: 100%;
    font-weight: 400;
    line-height: 1.2;
  }
  .btn {
    background-color: transparent;
    border-color: white;
    font-size: 15px;
    border-radius: 0;
    width: 200px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

}

@media only screen and (max-width: 425px) {
  .btn {
    width: 50%;
  }
  #slider{
    padding:50px 20px;
  }
  ::v-deep .carousel-item {
    height: 350px;
  }
}
@media only screen and (max-width: 768px) {
  .formSection {
    padding-top: 30px;
    background: white;
    padding: 0;
    font-size: 13pt;
    color: #00477c;
    padding-top: 30px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
  }
  .appImage {
    width: 100%;
    position: initial;
    margin-top: 0;
  }
  .home.container.nopadMod {
    padding: 0px;
    background-color: #fff;
  }
  .mobHide {
    display: none;
  }
  .mobShow {
    display: block;
  }
}
@media only screen and (max-width: 1400px) {
  .appImageLeft {
    display: none;
  }
  .appImage {
    width: 100%;
    position: inherit;
    right: 12em;
    margin-top: 0px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
    margin-left: 0px;
    margin-right: 0px;
  }
}
@media only screen and (min-width: 769px) {
  .deskHide{
    display: none;
  }
}
</style>
